/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import React, { lazy } from 'react';
import { Redirect } from 'react-router-dom';

import AuthLayout from './layouts/Auth';
import ErrorLayout from './layouts/Error';
import DashboardLayout from './layouts/Dashboard';
import DashboardView from './views/Dashboard';

const routes = [
  {
    path: '/',
    exact: true,
    component: () => <Redirect to="/dashboard" />
  },
  {
    path: '/auth',
    component: AuthLayout,
    routes: [
      {
        path: '/auth/login',
        exact: true,
        component: lazy(() => import('views/Login'))
      },
      {
        component: () => <Redirect to="/errors/error-404" />
      }
    ]
  },
  {
    path: '/errors',
    component: ErrorLayout,
    routes: [
      {
        path: '/errors/error-401',
        exact: true,
        component: lazy(() => import('views/Error401'))
      },
      {
        path: '/errors/error-404',
        exact: true,
        component: lazy(() => import('views/Error404'))
      },
      {
        path: '/errors/error-500',
        exact: true,
        component: lazy(() => import('views/Error500'))
      },
      {
        component: () => <Redirect to="/errors/error-404" />
      }
    ]
  },
  {
    route: '*',
    component: DashboardLayout,
    routes: [
      {
        path: '/dashboard',
        exact: true,
        component: DashboardView
      },
      {
        path: '/instructors',
        exact: true,
        component: lazy(() => import('views/InstructorsList'))
      },
      {
        path: '/instructors/:id',
        exact: true,
        component: lazy(() => import('views/InstructorsDetails'))
      },
      {
        path: '/instructors/:id/:tab',
        exact: true,
        component: lazy(() => import('views/InstructorsDetails'))
      },
      {
        path: '/correctors',
        exact: true,
        component: lazy(() => import('views/CorrectorsList'))
      },
      {
        path: '/correctors/:id',
        exact: true,
        component: lazy(() => import('views/CorrectorsDetails'))
      },
      {
        path: '/correctors/:id/:tab',
        exact: true,
        component: lazy(() => import('views/CorrectorsDetails'))
      },
      {
        path: '/courses',
        exact: true,
        component: lazy(() => import('views/CoursesList'))
      },
      {
        path: '/courses/:id',
        exact: true,
        component: lazy(() => import('views/CoursesDetails'))
      },
      {
        path: '/courses/:id/:tab',
        exact: true,
        component: lazy(() => import('views/CoursesDetails'))
      },
      {
        path: '/exams',
        exact: true,
        component: lazy(() => import('views/ExamsList'))
      },
      {
        path: '/exams/add',
        exact: true,
        component: lazy(() => import('views/ExamAdd'))
      },
      {
        path: '/exams/:id',
        exact: true,
        component: lazy(() => import('views/ExamsDetails'))
      },
      {
        path: '/exams/:id/:tab',
        exact: true,
        component: lazy(() => import('views/ExamsDetails'))
      },
      {
        path: '/corrections/:id/',
        exact: true,
        component: lazy(() => import('views/Corrections'))
      },
      {
        path: '/corrections/:id/:location/',
        exact: true,
        component: lazy(() => import('views/Correction'))
      },
      {
        path: '/corrections/:id/:location/marks/',
        exact: true,
        component: lazy(() => import('views/Correction'))
      },
      // {
      //   path: '/reports/',
      //   exact: true,
      //   component: lazy(() => import('views/ReportsList'))
      // },
      // {
      //   path: '/reports/:id/',
      //   exact: true,
      //   component: lazy(() => import('views/ReportDetails'))
      // },
      // {
      //   path: '/reports/:id/:tab/',
      //   exact: true,
      //   component: lazy(() => import('views/ReportDetails'))
      // },
      {
        component: () => <Redirect to="/errors/error-404" />
      }
    ]
  }
];

export default routes;
